module.exports = __webpack_public_path__ + "img/KGZ.910770a1.svg";